import * as React from "react";
import _ from "lodash";
import {
  Cell,
  Column,
  Table2,
  RenderMode,
  ColumnHeaderCell,
} from "@blueprintjs/table";
import { Icon } from "@blueprintjs/core";
import { useUnitActions, useUnitState } from "context/";
import { css } from "@emotion/core";

const AssetInspector = ({
  setShowCustomMeasurementDialog,
  data,
  raw,
  surveyLocked,
}) => {
  const { convert } = useUnitActions();
  const { unit, conversions } = useUnitState();

  if (!data || Array.isArray(data) === false || data.length === 0) return null;

  const editableRenderer = (rowIndex: number, columnIndex: number) => {
    const row = data[rowIndex];

    return (
      <Cell
        style={{
          padding: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        truncated={false}
        wrapText={true}
      >
        {row.editable && surveyLocked === false ? (
          <button
            css={css`
              padding: 0.5rem 1rem;
              background-color: transparent;
              border: none;
              color: white;
              display: flex;
              align-items: center;
              justify-content: center;
            `}
            onClick={() => {
              if (surveyLocked) {
                return;
              }
              setShowCustomMeasurementDialog(row.index);
            }}
          >
            <Icon icon="edit" size={12} />
          </button>
        ) : (
          " "
        )}
      </Cell>
    );
  };

  const labelRenderer = (rowIndex: number, columnIndex: number) => {
    return <Cell>{data[rowIndex].label}</Cell>;
  };

  const valueRenderer = (rowIndex: number, columnIndex: number) => {
    const row = data[rowIndex];

    const conversion = conversions.find(({ type }) => type === row.unit);
    const displayUnit =
      conversion === undefined
        ? ""
        : unit === "sae"
        ? conversion.imperial_unit
        : conversion.metric_unit;

    return row.editable ? (
      <Cell intent={row.value ? "none" : "danger"} style={{ padding: 0 }}>
        <button
          css={css`
            width: 100%;
            padding: 0.25rem 10px;
            text-align: left;
            background-color: transparent;
            border: none;
            color: white;
          `}
          onDoubleClick={() => {
            if (surveyLocked) {
              return;
            }
            setShowCustomMeasurementDialog(row.index);
          }}
        >
          {row.value} {row.value ? displayUnit : "Unknown"}
        </button>
      </Cell>
    ) : (
      <Cell>{row.value}</Cell>
    );
  };

  return (
    <Table2
      numRows={data.length}
      cellRendererDependencies={[data, unit]}
      getCellClipboardData={(row: number, column: number) => {
        if (raw[row].unit && typeof raw[row].value === "number") {
          return convert(raw[row].value, raw[row].unit, false, false);
        }

        return data[row].value;
      }}
      columnWidths={[32, 172, 152]}
      enableColumnResizing={false}
      enableRowHeader={false}
      enableMultipleSelection={false}
      enableGhostCells
      renderMode={RenderMode.NONE}
      onCopy={() => null}
    >
      <Column name="" cellRenderer={editableRenderer} />
      <Column
        columnHeaderCellRenderer={() => (
          <ColumnHeaderCell>
            <div
              css={css`
                width: 100%;
                padding: 0.5rem;
                font-size: 0.8rem;
                font-weight: 600;
              `}
            >
              Label
            </div>
          </ColumnHeaderCell>
        )}
        cellRenderer={labelRenderer}
      />
      <Column
        columnHeaderCellRenderer={() => (
          <ColumnHeaderCell>
            <div
              css={css`
                width: 100%;
                padding: 0.5rem;
                font-size: 0.8rem;
                font-weight: 600;
              `}
            >
              Value/Unit
            </div>
          </ColumnHeaderCell>
        )}
        cellRenderer={valueRenderer}
      />
    </Table2>
  );
};

export default AssetInspector;
